import { createSignal, Show, For, useContext } from 'solid-js';
import { StyledFirstLevelMenu, StyledFirstLevelMenuItem, StyledListItem, StyledSecondaryMenuItem, StyledSecondaryMenuItemParentLink, StyledUnorderedList } from './first-level-menu.styles';
import type { FirstLevelMenuProps } from './first-level-menu-types';
import type { MenuItem } from '../../../types/primary-menu-types';
import { removeTrailingSlash } from '../../../../../tools/remove-trailing-slash';
import removeAmpersand from '../../../../../tools/remove-ampersand';
import clsx from 'clsx';
import { ChevronUpBoldIcon } from '../../../../icons-library/chevron-up-bold';
import { isExternalLink } from '../../../../../tools/check-is-external-url';
import { AppContext } from '../../../../../app-context-provider/app-context-provider';

export const FirstLevelMenu = (props: FirstLevelMenuProps) => {
    const { localize } = useContext(AppContext);

    const [open, setOpen] = createSignal(false);

    return (
        <StyledListItem isOpen={open()}>
            <StyledFirstLevelMenu>
                <StyledFirstLevelMenuItem 
                    onClick={() => setOpen(!open())}
                    aria-label={open() 
                        ? localize('close-submenu', 'Close Submenu') 
                        : localize('open-submenu', 'Open Submenu')
                    }
                >
                    {removeAmpersand(props.parent.title)}

                    <span
                        class={clsx('ml-[0.5rem]', 'transform', 'translate-y-[1px] transform transition-transform duration-200 origin-center', {
                            'rotate-180': open(),
                        })}
                    >
                        <ChevronUpBoldIcon width={1.5} height={1.5} ariaLabel={localize('toggle-submenu', 'Toggle Submenu')} />
                    </span>
                </StyledFirstLevelMenuItem>
                <Show when={open()}>
                    <StyledUnorderedList>
                        <Show when={props.parent.url}>
                            <li>
                                <StyledSecondaryMenuItemParentLink
                                    href={removeTrailingSlash(props.parent.url)}
                                    onClick={() => props.onLinkClick()}
                                    {...(isExternalLink(props.parent.url)
                                        ? {
                                            target: '_blank',
                                            rel: 'noopener noreferrer',
                                        }
                                        : {})} 
                                >
                                    {removeAmpersand(props.parent.title)}
                                </StyledSecondaryMenuItemParentLink>
                            </li>
                        </Show>
                        <For each={props.parent.children}>
                            {(link: MenuItem) => (
                                <li>
                                    <StyledSecondaryMenuItem
                                        href={removeTrailingSlash(link.url)}
                                        onClick={() => props.onLinkClick()}
                                        {...(isExternalLink(link.url)
                                            ? {
                                                target: '_blank',
                                                rel: 'noopener noreferrer',
                                            }
                                            : {})} 
                                    >
                                        {removeAmpersand(link.title)}
                                    </StyledSecondaryMenuItem>
                                </li>
                            )}
                        </For>
                    </StyledUnorderedList>
                </Show>
            </StyledFirstLevelMenu>
        </StyledListItem>
    );
};
